import React from 'react';
import { StatusFeedback } from '../../../../components/core';
import { IconAlertCircle } from '../../../../components/icons/IconAlertCircle';

export const SurveyNoActiveFeedback = (): JSX.Element => (
  <StatusFeedback.info Icon={IconAlertCircle} testID="survey-no-active-feedback">
    There isn’t an active survey available right now, but your school will let you know when the
    next survey is launched.
  </StatusFeedback.info>
);
